// FEEL: pouch early-access popup + Klaviyo list signup.
// - [data-feel-early] buttons open #feel-ea (data-flavor / data-color / data-ink / data-image personalise it)
// - the popup form and any form[data-feel-klaviyo] subscribe the email to a Klaviyo list via Klaviyo's
//   public client API (the same list their own "Pouches Popup" form uses).

const API = 'https://a.klaviyo.com/client/subscriptions/';

async function subscribe(company, list, email, source) {
  const res = await fetch(`${API}?company_id=${encodeURIComponent(company)}`, {
    method: 'POST',
    // Klaviyo's Cloudflare returns 403 (no CORS header) to any client-API POST that carries a Referer.
    referrerPolicy: 'no-referrer',
    headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: { email } } },
        },
        relationships: { list: { data: { type: 'list', id: list } } },
      },
    }),
  });
  if (!res.ok) throw new Error('Klaviyo ' + res.status);
}

const validEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);

if (!window.__feelEarly) {
  window.__feelEarly = true;
  const dlg = document.getElementById('feel-ea');

  const reset = () => {
    dlg.querySelector('[data-feel-ea-form-wrap]').hidden = false;
    dlg.querySelector('[data-feel-ea-ok]').hidden = true;
    const err = dlg.querySelector('[data-feel-ea-err]');
    err.hidden = true;
    err.textContent = '';
  };

  // remembered per browser: closed time + signed up (wrapped: storage can be blocked)
  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} },
  };
  const K_CLOSED = 'feel-ea-closed-at';
  const K_DONE = 'feel-ea-subscribed';

  const openPopup = (d = {}) => {
    if (!dlg || dlg.open) return;
    reset();
    dlg.dataset.flavor = d.flavor || '';
    const fl = dlg.querySelector('[data-feel-ea-flavor]');
    fl.textContent = d.flavor || 'Smart Stack™ Pouches';
    fl.innerHTML = fl.innerHTML.replace(/™/g, '<sup class="feel-tm">™</sup>');
    if (d.image) dlg.querySelector('[data-feel-ea-img]').src = d.image;
    dlg.style.setProperty('--ea-bg', d.color || '#b4f13a');
    dlg.style.setProperty('--ea-ink', d.ink || '#0a0a0a');
    dlg.showModal();
    setTimeout(() => dlg.querySelector('input[type="email"]').focus(), 60);
  };

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-feel-early]');
    if (trigger && dlg) {
      e.preventDefault();
      openPopup(trigger.dataset);
      return;
    }
    if (dlg && (e.target.closest('[data-feel-ea-close]') || e.target === dlg)) dlg.close();
  });

  // closing it (X, Esc, outside click) counts as "seen": the auto-open waits before showing again
  if (dlg) dlg.addEventListener('close', () => { if (store.get(K_DONE) !== '1') store.set(K_CLOSED, String(Date.now())); });

  // corner tab (off unless Theme settings > FEEL turns it on): after someone closes the popup (and hasn't signed
  // up), a small tab sits bottom-left to reopen it. The x hides it for the same number of days as the auto-open.
  const tabEl = dlg && dlg.dataset.tab === '1' ? document.querySelector('[data-feel-ea-tab]') : null;
  const K_TAB = 'feel-ea-tab-hidden-at';
  const tabDays = parseFloat((dlg && dlg.dataset.days) || '7');
  const refreshTab = () => {
    if (!tabEl || !dlg) return;
    const hiddenAt = parseInt(store.get(K_TAB) || '0', 10);
    const show = store.get(K_DONE) !== '1' && !!store.get(K_CLOSED) && !dlg.open && !(hiddenAt && Date.now() - hiddenAt < tabDays * 864e5);
    tabEl.hidden = !show;
  };
  if (tabEl) {
    tabEl.querySelector('[data-feel-ea-tab-x]').addEventListener('click', () => { store.set(K_TAB, String(Date.now())); refreshTab(); });
    if (dlg) {
      dlg.addEventListener('close', () => setTimeout(refreshTab, 0));
      new MutationObserver(refreshTab).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    }
    refreshTab();
  }

  // this popup replaces Klaviyo's own pouch popup (form id in data-kl-replace): hide it + its teaser tab, and
  // close it properly if it opens so Klaviyo releases its page scroll lock
  const KL = dlg && dlg.dataset.klReplace;
  if (KL) {
    const css = document.createElement('style');
    css.textContent = '[role="dialog"]:has(form[data-testid="klaviyo-form-' + KL + '"]),.kl-teaser-' + KL + '{display:none!important}';
    document.head.appendChild(css);
    const closeKl = () => {
      const f = document.querySelector('form[data-testid="klaviyo-form-' + KL + '"]');
      const box = f && f.closest('[role="dialog"]');
      const btn = box && box.querySelector('.klaviyo-close-form');
      if (btn && !btn.dataset.feelClosed) { btn.dataset.feelClosed = '1'; btn.click(); }
    };
    new MutationObserver(closeKl).observe(document.body, { childList: true, subtree: true });
  }

  // auto-open for new visitors (Theme settings > FEEL): once, after the delay or on desktop exit-intent, whichever
  // comes first. Never on pages that already show the signup form inline (waitlist page, pouches page).
  // ?feel_popup=1 forces it for testing.
  const force = /[?&]feel_popup=1/.test(location.search);
  const inlineForm = document.querySelector('main form[data-feel-klaviyo]');
  if (dlg && ((dlg.dataset.auto === '1' && !inlineForm) || force)) {
    const days = parseFloat(dlg.dataset.days || '7');
    const closedAt = parseInt(store.get(K_CLOSED) || '0', 10);
    const due = force || (store.get(K_DONE) !== '1' && (!closedAt || Date.now() - closedAt > days * 864e5));
    if (due) {
      let fired = false;
      const autoOpen = () => {
        if (fired) return;
        // step aside if something else is open: cart drawer, menu, another dialog, or Klaviyo's own popup
        const busy = document.querySelector('dialog[open]') || document.querySelector('details[open].menu-drawer-container')
          || [...document.querySelectorAll('[role="dialog"]')].some((el) => el !== dlg && el.offsetWidth > 0 && /klaviyo|kl-/i.test(el.className + ' ' + (el.getAttribute('aria-label') || '')));
        if (busy && !force) return;
        if (document.visibilityState === 'hidden' && !force) return;
        fired = true;
        openPopup({});
      };
      setTimeout(autoOpen, (force ? 1 : parseFloat(dlg.dataset.delay || '9')) * 1000);
      // exit-intent: pointer leaves through the top of the window (desktop only, not in the first 3 seconds)
      const armedAt = Date.now() + 3000;
      if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
        document.addEventListener('mouseout', (e) => {
          if (!e.relatedTarget && e.clientY <= 0 && Date.now() > armedAt) autoOpen();
        });
      }
    }
  }

  // signup analytics: GTM dataLayer event, Meta Pixel Lead (when fbq is on the page) and a Shopify customer event
  // that a custom pixel can subscribe to (Settings > Customer events)
  const trackSignup = (where, flavor) => {
    const detail = { form_location: where, flavor: flavor || '', list: (dlg && dlg.dataset.list) || '' };
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'waitlist_signup', ...detail }); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'Pouch waitlist', content_category: where }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('waitlist_signup', detail); } catch (e) {}
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    const isPopup = form.matches('[data-feel-ea-form]');
    const isBand = form.matches('form[data-feel-klaviyo]') && !!form.dataset.list;
    if (!isPopup && !isBand) return;
    e.preventDefault();
    const input = form.querySelector('input[type="email"]');
    const email = (input.value || '').trim();
    let err = form.querySelector('[data-feel-ea-err]') || form.querySelector('.feel-signup__err');
    if (!err) {
      err = document.createElement('p');
      err.className = 'feel-signup__err';
      err.setAttribute('role', 'alert');
      err.hidden = true;
      form.appendChild(err);
    }
    const btn = form.querySelector('button[type="submit"]');
    const show = (msg) => { if (err) { err.textContent = msg; err.hidden = false; } };
    if (!validEmail(email)) { show('Enter a valid email address.'); input.focus(); return; }
    const host = isPopup ? dlg : form;
    const company = host.dataset.company || 'YqNR7h';
    const list = host.dataset.list || 'W8DhQ3';
    const flavor = isPopup ? dlg.dataset.flavor : '';
    btn.disabled = true;
    try {
      await subscribe(company, list, email, 'Feel site: pouch early access' + (flavor ? ' (' + flavor + ')' : ''));
      store.set(K_DONE, '1');
      trackSignup(isPopup ? 'popup' : (form.dataset.location || 'page form'), flavor);
      if (typeof refreshTab === 'function') refreshTab();
      if (isPopup) {
        dlg.querySelector('[data-feel-ea-form-wrap]').hidden = true;
        dlg.querySelector('[data-feel-ea-ok]').hidden = false;
      } else {
        const ok = document.createElement('p');
        ok.className = 'feel-signup__ok';
        ok.setAttribute('role', 'status');
        ok.textContent = form.dataset.success || "You're on the list.";
        form.replaceChildren(ok);
      }
      input.value = '';
    } catch (ex) {
      show('Something went wrong. Please try again.');
    } finally {
      btn.disabled = false;
    }
  });
}
